import { render, staticRenderFns } from "./Objection.vue?vue&type=template&id=241921ff&scoped=true&"
import script from "./Objection.vue?vue&type=script&lang=js&"
export * from "./Objection.vue?vue&type=script&lang=js&"
import style0 from "./Objection.vue?vue&type=style&index=0&id=241921ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241921ff",
  null
  
)

component.options.__file = "Objection.vue"
export default component.exports